import { Colors } from '@src/colors';
import styled from 'styled-components';

export const Container = styled.div<{ variant: string }>`
    display: flex;
    border-radius: 10px;
    padding: 3px 7px;
    border: 2px solid
        ${({ variant = 'alert' }) => (variant === 'caution' ? Colors.awareness20 : Colors.alert)};

    color: ${({ variant = 'alert' }) =>
        variant === 'caution' ? Colors.awareness20 : Colors.alert};
    align-items: center;

    svg {
        margin-right: 5px;
        width: 17px;
        height: 16px;

        path {
            fill: ${({ variant = 'alert' }) =>
                variant === 'caution' ? Colors.awareness20 : Colors.alert};
        }
    }
`;

export const Label = styled.div`
    font-weight: 800;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 2px;
    margin-bottom: 0;
    text-transform: uppercase;
`;
